import { MaliciousCallMailConfigRemoteDto } from 'src/generated/signalR/malicious-call-mail-config-remote-dto';

export class MaliciousCallMailConfigChanged {
   public static readonly type = '[Malicious Call Mail Config] mail configuration changed';

   constructor(public mailconfig: MaliciousCallMailConfigRemoteDto) {}
}
